import { createGaSender } from 'reactApp/utils/ga';

export const sendMyofficeGa = createGaSender('myoffice');
